import React from "react";
import { Form } from "react-bootstrap";
import FormError from "../../../FormError";
import { FormikProductFormField } from "../../index";

const NameField = (props: FormikProductFormField) => {
  const { formik } = props;

  return (
    <Form.Group controlId="productName">
      <Form.Label>Name</Form.Label>
      <Form.Control
        name="name"
        type="text"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.name}
      />

      <FormError message={formik.errors.name} when={formik.touched.name && Boolean(formik.errors.name)} />
    </Form.Group>
  )
}

export default NameField;
